// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* At the top right of the notebook page, on the white band behind the title,
   above the connections bar and clear of the scrollbar. */
.zHKXB_vXCXq8VYdAr0uV {
  position: fixed;
  z-index: 90;
  top: calc(var(--curio-top-bar-height) + 15px);
  right: 32px;
  width: 64px;
}
`, "",{"version":3,"sources":["webpack://./src/components/notebook/NotebookRunAll.module.css"],"names":[],"mappings":"AAAA;0DAC0D;AAC1D;EACE,eAAe;EACf,WAAW;EACX,6CAA6C;EAC7C,WAAW;EACX,WAAW;AACb","sourcesContent":["/* At the top right of the notebook page, on the white band behind the title,\n   above the connections bar and clear of the scrollbar. */\n.dock {\n  position: fixed;\n  z-index: 90;\n  top: calc(var(--curio-top-bar-height) + 15px);\n  right: 32px;\n  width: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dock": `zHKXB_vXCXq8VYdAr0uV`
};
export default ___CSS_LOADER_EXPORT___;
